(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"index_atlas_1", frames: [[1044,1238,53,75],[947,1446,116,50],[1050,1186,105,50],[795,1238,247,50],[795,1394,229,50],[795,1290,246,50],[795,1134,303,50],[795,1186,253,50],[795,1082,323,50],[795,1446,150,50],[795,1342,238,50],[1120,1082,104,50],[1532,1020,514,573],[0,0,1530,1080],[1532,0,386,1018],[0,1082,793,500]]},
		{name:"index_atlas_2", frames: [[0,0,1920,1080]]},
		{name:"index_atlas_3", frames: [[0,0,1920,1080]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_15 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_14 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_13 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_12 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_11 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_10 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_9 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_8 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_7 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_6 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_4 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_3 = function() {
	this.initialize(img.CachedBmp_3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3840,2160);


(lib.CachedBmp_2 = function() {
	this.initialize(img.CachedBmp_2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,3441,7084);


(lib.CachedBmp_16 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.Image = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.Bitmap1 = function() {
	this.initialize(ss["index_atlas_3"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.fachada = function() {
	this.initialize(ss["index_atlas_2"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.Fachada_recorte = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.Nuvem1 = function() {
	this.initialize(ss["index_atlas_1"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.zoom_white = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#424154").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#424154").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#424154").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_white, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.zoom_brack = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#000000").setStrokeStyle(4.7,1,1).moveTo(-4.8,-4.8).lineTo(4.8,4.8);
	this.shape.setTransform(11.75,11.75);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#000000").setStrokeStyle(3.5,1,1).moveTo(9.6,-9.6).curveTo(11.8,-7.3,12.8,-4.5).curveTo(13.5,-2.4,13.5,0).curveTo(13.5,4.7,10.8,8.2).curveTo(10.3,8.8,9.6,9.6).lineTo(9.6,9.6).curveTo(5.7,13.5,0,13.5).curveTo(-5.6,13.5,-9.6,9.6).curveTo(-13.5,5.7,-13.5,0).curveTo(-13.5,-5.7,-9.6,-9.6).curveTo(-5.6,-13.5,0,-13.5).curveTo(5.7,-13.5,9.6,-9.6).closePath();
	this.shape_1.setTransform(-3,-3);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#000000").beginStroke().moveTo(-1.9,8.7).curveTo(-1.9,8.7,-2,8.7).curveTo(-2,8.6,-2.1,8.6).curveTo(-2.1,8.6,-2.2,8.6).curveTo(-2.2,8.5,-2.2,8.5).lineTo(-2.4,8.1).lineTo(-2.4,2.6).curveTo(-2.4,2.5,-2.4,2.5).curveTo(-2.4,2.4,-2.4,2.4).curveTo(-2.5,2.4,-2.5,2.3).curveTo(-2.5,2.3,-2.5,2.3).lineTo(-8.1,2.3).curveTo(-8.2,2.3,-8.3,2.3).curveTo(-8.3,2.3,-8.4,2.3).curveTo(-8.4,2.3,-8.4,2.2).curveTo(-8.5,2.2,-8.5,2.1).lineTo(-8.7,1.8).lineTo(-8.7,-1.8).curveTo(-8.7,-1.9,-8.7,-1.9).curveTo(-8.6,-2,-8.6,-2).curveTo(-8.6,-2.1,-8.6,-2.1).curveTo(-8.5,-2.1,-8.5,-2.2).curveTo(-8.5,-2.2,-8.4,-2.3).curveTo(-8.4,-2.3,-8.4,-2.3).curveTo(-8.3,-2.3,-8.3,-2.4).curveTo(-8.2,-2.4,-8.1,-2.4).lineTo(-2.5,-2.4).curveTo(-2.5,-2.4,-2.5,-2.4).curveTo(-2.5,-2.4,-2.4,-2.4).curveTo(-2.4,-2.5,-2.4,-2.5).curveTo(-2.4,-2.6,-2.4,-2.7).lineTo(-2.4,-8.2).curveTo(-2.4,-8.2,-2.4,-8.3).curveTo(-2.4,-8.3,-2.4,-8.4).curveTo(-2.4,-8.4,-2.3,-8.5).curveTo(-2.3,-8.5,-2.2,-8.6).lineTo(-1.9,-8.7).lineTo(1.8,-8.7).lineTo(2.1,-8.6).curveTo(2.2,-8.5,2.2,-8.5).curveTo(2.3,-8.4,2.3,-8.4).curveTo(2.3,-8.3,2.3,-8.3).curveTo(2.3,-8.2,2.3,-8.2).lineTo(2.3,-2.7).curveTo(2.3,-2.6,2.3,-2.5).curveTo(2.4,-2.5,2.4,-2.4).curveTo(2.4,-2.4,2.4,-2.4).curveTo(2.5,-2.4,2.5,-2.4).lineTo(8.1,-2.4).curveTo(8.1,-2.4,8.2,-2.4).curveTo(8.3,-2.3,8.3,-2.3).curveTo(8.4,-2.3,8.4,-2.3).curveTo(8.5,-2.2,8.5,-2.2).curveTo(8.6,-2.1,8.6,-2.1).curveTo(8.6,-2.1,8.6,-2).curveTo(8.7,-2,8.7,-1.9).curveTo(8.7,-1.9,8.7,-1.8).lineTo(8.7,1.8).lineTo(8.5,2.1).curveTo(8.5,2.2,8.4,2.2).curveTo(8.4,2.3,8.3,2.3).curveTo(8.3,2.3,8.2,2.3).curveTo(8.1,2.3,8.1,2.3).lineTo(2.5,2.3).lineTo(2.4,2.4).lineTo(2.3,2.6).lineTo(2.3,8.1).lineTo(2.1,8.5).curveTo(2.1,8.5,2.1,8.6).curveTo(2,8.6,2,8.6).curveTo(1.9,8.6,1.9,8.7).curveTo(1.8,8.7,1.8,8.7).closePath();
	this.shape_2.setTransform(-2.975,-2.975);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.zoom_brack, new cjs.Rectangle(-18.2,-18.2,37.099999999999994,37.099999999999994), null);


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-960,500).lineTo(-960,-500).lineTo(960,-500).lineTo(960,500).closePath();
	this.shape.setTransform(960,540.0009,1,1.08);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.size_90x90 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0)").beginStroke().moveTo(-45,45).lineTo(-45,-45).lineTo(45,-45).lineTo(45,45).closePath();
	this.shape.setTransform(45,45);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_90x90, new cjs.Rectangle(0,0,90,90), null);


(lib.vertical = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,2,1).moveTo(0,-8).lineTo(0,8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.vertical, new cjs.Rectangle(-1,-9,2,18), null);


(lib.square = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// square
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#9881D1").beginStroke().moveTo(-4,4).lineTo(-4,-4).lineTo(4,-4).lineTo(4,4).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.square, new cjs.Rectangle(-4,-4,8,8), null);


(lib.ball = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// ball
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#D4CFC4").beginStroke().moveTo(-2.8,2.9).curveTo(-4,1.7,-4,0).curveTo(-4,-1.6,-2.8,-2.8).curveTo(-1.6,-4,0,-4).curveTo(1.6,-4,2.8,-2.8).curveTo(4,-1.6,4,0).curveTo(4,1.7,2.8,2.9).curveTo(1.6,4,0,4).curveTo(-1.6,4,-2.8,2.9).closePath();

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ball, new cjs.Rectangle(-4,-4,8,8), null);


(lib.pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("rgba(255,255,255,0.498)").beginStroke().moveTo(-67.4,30).lineTo(-67.4,-30).lineTo(67.4,-30).lineTo(67.4,30).closePath();
	this.shape.setTransform(67.4,30);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.pseudo, new cjs.Rectangle(0,0,134.8,60), null);


(lib.arrow_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#F1CB8A").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.arrow_up, new cjs.Rectangle(-22.6,0,45.2,22.7), null);


(lib.solid = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2,0,1).moveTo(-960,0).lineTo(960,0);
	this.shape.setTransform(960,1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.solid, new cjs.Rectangle(-1,0,1922,2), null);


(lib.gradient = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginLinearGradientFill(["#B4B0BF","#9881D1"],[0,1],-960,0,960,0).beginStroke().moveTo(-960,2).lineTo(-960,-2).lineTo(960,-2).lineTo(960,2).closePath();
	this.shape.setTransform(960,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.gradient, new cjs.Rectangle(0,-2,1920,4), null);


(lib._double = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#B4B0BF").setStrokeStyle(2,1,1).moveTo(400,0).lineTo(-400,0);
	this.shape.setTransform(700,60);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#9881D1").setStrokeStyle(2,1,1).moveTo(300,0).lineTo(-300,0);
	this.shape_1.setTransform(300,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib._double, new cjs.Rectangle(-1,-1,1102,62), null);


(lib.logo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {none:1,small:2,medium:3,large:4};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(5));

	// flash0_ai
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(55.3,8.7).curveTo(51.7,5,51.7,-0.1).curveTo(51.7,-5.1,55.3,-8.7).curveTo(58.9,-12.4,63.8,-12.3).curveTo(68.6,-12.4,72.3,-8.7).curveTo(76,-5,76,-0.1).curveTo(76,5,72.3,8.7).curveTo(68.6,12.4,63.8,12.4).curveTo(58.9,12.4,55.3,8.7).closePath().moveTo(61.9,-10.7).curveTo(58.1,-10.1,56.3,-6.5).curveTo(54.5,-3,55.4,1.5).curveTo(56.1,6,59,8.7).curveTo(61.9,11.3,65.7,10.6).curveTo(69.4,10.1,71.3,6.3).curveTo(73.1,2.8,72.3,-1.8).curveTo(71.6,-6.3,68.6,-8.7).curveTo(66.2,-10.8,63.3,-10.8).lineTo(61.9,-10.7).closePath().moveTo(28,8.7).curveTo(24.3,5,24.3,-0.1).curveTo(24.3,-5.1,28,-8.7).curveTo(31.6,-12.4,36.4,-12.3).curveTo(41.3,-12.4,44.9,-8.7).curveTo(48.6,-5,48.6,-0.1).curveTo(48.6,5,44.9,8.7).curveTo(41.3,12.4,36.4,12.4).curveTo(31.6,12.4,28,8.7).closePath().moveTo(34.5,-10.7).curveTo(30.8,-10.1,29,-6.5).curveTo(27.2,-3,28,1.5).curveTo(28.8,6,31.7,8.7).curveTo(34.6,11.3,38.3,10.6).curveTo(42.1,10.1,44,6.3).curveTo(45.8,2.8,45,-1.8).curveTo(44.2,-6.3,41.3,-8.7).curveTo(38.9,-10.8,35.9,-10.8).lineTo(34.5,-10.7).closePath().moveTo(-54.2,8.7).curveTo(-58.1,5.1,-58.1,0).curveTo(-58.1,-5.1,-54.2,-8.7).curveTo(-50.4,-12.4,-45.2,-12.3).curveTo(-41.1,-12.4,-37.8,-10).lineTo(-39.3,-8.4).curveTo(-40.9,-9.8,-43,-10.4).curveTo(-45.1,-10.9,-47.2,-10.7).curveTo(-51.3,-10,-53.3,-6.5).curveTo(-55.3,-2.9,-54.5,1.5).curveTo(-53.6,6,-50.4,8.7).curveTo(-47.2,11.3,-43.1,10.6).curveTo(-41.1,10.4,-39.5,9.4).lineTo(-38.5,10.5).curveTo(-41.5,12.3,-45.2,12.4).curveTo(-50.4,12.4,-54.2,8.7).closePath().moveTo(-81.8,8.7).curveTo(-85.4,5,-85.4,-0.1).curveTo(-85.4,-5.1,-81.8,-8.7).curveTo(-78.1,-12.4,-73.3,-12.3).curveTo(-68.5,-12.4,-64.8,-8.7).curveTo(-61.1,-5,-61.1,-0.1).curveTo(-61.1,5,-64.8,8.7).curveTo(-68.4,12.4,-73.3,12.4).curveTo(-78.1,12.4,-81.8,8.7).closePath().moveTo(-75.2,-10.7).curveTo(-79,-10.1,-80.8,-6.5).curveTo(-82.5,-3,-81.7,1.5).curveTo(-80.9,6,-78.1,8.7).curveTo(-75.2,11.3,-71.4,10.6).curveTo(-67.6,10.1,-65.8,6.3).curveTo(-63.9,2.8,-64.7,-1.8).curveTo(-65.5,-6.3,-68.4,-8.7).curveTo(-70.8,-10.8,-73.8,-10.8).lineTo(-75.2,-10.7).closePath().moveTo(80.1,12).lineTo(80.1,-10.4).lineTo(80.1,-11.1).lineTo(80.1,-11.9).lineTo(87.4,-11.9).curveTo(93.3,-11.8,96.8,-8.7).curveTo(100.4,-5.4,100.4,0.1).curveTo(100.4,2.9,99.2,5.3).curveTo(98.1,7.4,96.2,9.1).curveTo(92.9,12,87.4,12).closePath().moveTo(83.7,10.7).lineTo(87.4,10.7).curveTo(96.7,10.7,96.7,0.1).curveTo(96.7,-6.1,93.5,-8.7).curveTo(91.3,-10.5,87.4,-10.5).lineTo(83.7,-10.5).closePath().moveTo(-100.4,12).lineTo(-100.4,-11.9).lineTo(-96.8,-11.9).lineTo(-96.8,10.5).lineTo(-84.5,10.5).lineTo(-85.8,12).closePath().moveTo(10.7,12).lineTo(4.3,-2.9).lineTo(-2.2,12).lineTo(-5.4,12).lineTo(-14.8,-11.8).lineTo(-10.8,-11.8).lineTo(-2.6,9.2).lineTo(3.6,-4.7).lineTo(0.5,-11.8).lineTo(4.4,-11.8).lineTo(13.5,9.2).lineTo(21.9,-11.8).lineTo(23.6,-11.8).lineTo(13.9,12).closePath().moveTo(-18.9,12).lineTo(-28.9,1.2).lineTo(-30.9,3.4).lineTo(-30.9,12).lineTo(-34.6,12).lineTo(-34.6,-11.9).lineTo(-32.3,-11.9).lineTo(-32.3,-11.9).lineTo(-30.9,-11.9).lineTo(-30.9,1.2).lineTo(-18.9,-11.9).lineTo(-17.8,-11.9).lineTo(-17.8,-11.9).lineTo(-16.9,-11.9).lineTo(-26.5,-1.5).lineTo(-14.1,12).closePath();
	this.shape.setTransform(62.875,33.1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(71.1,11.2).curveTo(66.5,6.5,66.5,-0).curveTo(66.5,-6.5,71.1,-11.2).curveTo(75.8,-15.9,82.1,-15.9).curveTo(88.3,-15.9,93,-11.2).curveTo(97.7,-6.5,97.7,-0).curveTo(97.7,6.5,93,11.2).curveTo(88.3,15.9,82.1,15.9).curveTo(75.8,15.9,71.1,11.2).closePath().moveTo(79.7,-13.7).curveTo(74.8,-12.9,72.5,-8.3).curveTo(70.2,-3.8,71.3,2).curveTo(72.3,7.8,75.9,11.1).curveTo(79.7,14.6,84.4,13.7).curveTo(89.3,12.9,91.7,8.2).curveTo(94.1,3.5,93.1,-2.3).curveTo(92.1,-8,88.3,-11.2).curveTo(85.3,-13.9,81.6,-13.9).curveTo(80.6,-13.9,79.7,-13.7).closePath().moveTo(36,11.2).curveTo(31.3,6.5,31.3,-0).curveTo(31.3,-6.5,36,-11.2).curveTo(40.6,-15.9,46.9,-15.9).curveTo(53.1,-15.9,57.9,-11.2).curveTo(62.6,-6.5,62.6,-0).curveTo(62.6,6.5,57.9,11.2).curveTo(53.1,15.9,46.9,15.9).curveTo(40.6,15.9,36,11.2).closePath().moveTo(44.5,-13.7).curveTo(39.6,-12.9,37.3,-8.3).curveTo(35.1,-3.8,36,2).curveTo(37,7.8,40.8,11.1).curveTo(44.5,14.6,49.3,13.7).curveTo(54.1,12.9,56.6,8.2).curveTo(59,3.6,57.9,-2.3).curveTo(56.9,-8,53.1,-11.2).curveTo(50.1,-13.9,46.4,-13.9).curveTo(45.4,-13.9,44.5,-13.7).closePath().moveTo(-69.7,11.2).curveTo(-74.8,6.5,-74.8,0).curveTo(-74.8,-6.5,-69.7,-11.2).curveTo(-64.8,-15.9,-58,-15.9).curveTo(-52.8,-15.9,-48.6,-12.8).lineTo(-50.5,-10.8).curveTo(-52.7,-12.6,-55.3,-13.4).curveTo(-58,-14.1,-60.7,-13.7).curveTo(-66,-12.9,-68.6,-8.3).curveTo(-71.2,-3.8,-70,2).curveTo(-69,7.8,-64.9,11.1).curveTo(-60.7,14.6,-55.4,13.7).curveTo(-53,13.4,-50.8,12).lineTo(-49.5,13.4).curveTo(-53.5,15.9,-58,15.9).curveTo(-64.8,15.9,-69.7,11.2).closePath().moveTo(-105.1,11.2).curveTo(-109.9,6.5,-109.9,-0).curveTo(-109.9,-6.5,-105.1,-11.2).curveTo(-100.5,-15.9,-94.2,-15.9).curveTo(-88.1,-15.9,-83.3,-11.2).curveTo(-78.6,-6.5,-78.6,-0).curveTo(-78.6,6.5,-83.3,11.2).curveTo(-88.1,15.9,-94.2,15.9).curveTo(-100.5,15.9,-105.1,11.2).closePath().moveTo(-96.7,-13.7).curveTo(-101.5,-12.9,-103.9,-8.3).curveTo(-106.1,-3.8,-105.1,2).curveTo(-104.1,7.8,-100.4,11.1).curveTo(-96.7,14.6,-91.8,13.7).curveTo(-87,12.9,-84.6,8.2).curveTo(-82.2,3.5,-83.3,-2.3).curveTo(-84.3,-8,-88,-11.2).curveTo(-91,-13.9,-94.8,-13.9).curveTo(-95.7,-13.9,-96.7,-13.7).closePath().moveTo(103.1,15.4).lineTo(103.1,-13.4).lineTo(103.1,-14.4).curveTo(103,-15.3,103.1,-15.3).lineTo(112.5,-15.3).curveTo(120,-15.3,124.6,-11.2).curveTo(129.2,-7,129.2,0.1).curveTo(129.2,3.7,127.6,6.8).curveTo(126.3,9.6,123.8,11.7).curveTo(119.6,15.4,112.5,15.4).closePath().moveTo(107.7,13.8).lineTo(112.5,13.8).curveTo(124.5,13.8,124.5,0.1).curveTo(124.5,-7.8,120.3,-11.2).curveTo(117.4,-13.6,112.5,-13.6).lineTo(107.7,-13.6).closePath().moveTo(13.8,15.4).lineTo(5.6,-3.7).lineTo(-2.9,15.4).lineTo(-6.9,15.4).lineTo(-19.1,-15.2).lineTo(-13.9,-15.2).lineTo(-3.3,11.8).lineTo(4.6,-6).lineTo(0.6,-15.2).lineTo(5.7,-15.2).lineTo(17.5,11.8).lineTo(28.3,-15.2).lineTo(30.3,-15.2).lineTo(17.9,15.4).closePath().moveTo(-24.4,15.4).lineTo(-37.2,1.5).lineTo(-39.8,4.5).lineTo(-39.8,15.4).lineTo(-44.5,15.4).lineTo(-44.5,-15.3).lineTo(-39.8,-15.3).lineTo(-39.8,1.4).lineTo(-24.3,-15.3).lineTo(-21.7,-15.3).lineTo(-34,-1.9).lineTo(-18.1,15.4).closePath().moveTo(-129.2,15.4).lineTo(-129.1,-15.3).lineTo(-124.6,-15.3).lineTo(-124.6,13.5).lineTo(-108.7,13.5).lineTo(-110.4,15.4).closePath();
	this.shape_1.setTransform(62.9,33.075);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#FFFFFF").beginStroke().moveTo(13.7,21.7).lineTo(13.7,6.7).lineTo(15.2,6.7).lineTo(15.2,21.5).curveTo(15.2,22,15.5,22.1).curveTo(15.8,22.1,16,21.9).lineTo(16.3,23).curveTo(15.8,23.2,15,23.2).curveTo(13.7,23.2,13.7,21.7).closePath().moveTo(-4.2,22.3).curveTo(-4.9,21.3,-4.9,19.4).lineTo(-4.9,14.2).curveTo(-4.9,12.3,-4.2,11.3).curveTo(-3.5,10.4,-2.1,10.4).curveTo(-0.7,10.4,0,11.3).curveTo(0.8,12.3,0.8,14.2).lineTo(0.8,19.4).curveTo(0.8,21.3,0,22.3).curveTo(-0.7,23.2,-2.1,23.2).curveTo(-3.5,23.2,-4.2,22.3).closePath().moveTo(-3.5,13.8).lineTo(-3.5,19.9).curveTo(-3.5,22,-2.1,22).curveTo(-0.7,22,-0.7,19.9).lineTo(-0.7,13.8).curveTo(-0.7,11.6,-2.1,11.6).curveTo(-3.5,11.6,-3.5,13.8).closePath().moveTo(-13.6,22.3).curveTo(-14.3,21.3,-14.3,19.4).lineTo(-14.3,14.2).curveTo(-14.3,12.3,-13.6,11.3).curveTo(-12.8,10.4,-11.5,10.4).curveTo(-8.6,10.4,-8.6,14.2).lineTo(-8.6,19.4).curveTo(-8.6,23.3,-11.5,23.2).curveTo(-12.8,23.2,-13.6,22.3).closePath().moveTo(-12.9,13.8).lineTo(-12.9,19.9).curveTo(-12.9,22,-11.5,22).curveTo(-10.1,22,-10.1,19.9).lineTo(-10.1,13.8).curveTo(-10.1,11.6,-11.5,11.6).curveTo(-12.9,11.6,-12.9,13.8).closePath().moveTo(29,23).lineTo(29,13.7).curveTo(29,11.6,27.6,11.6).curveTo(26.2,11.6,26.2,13.7).lineTo(26.2,23).lineTo(24.7,23).lineTo(24.7,10.6).lineTo(25.8,10.6).lineTo(26,11.8).curveTo(26.5,10.4,28.1,10.4).curveTo(30.4,10.4,30.4,13.6).lineTo(30.4,23).closePath().moveTo(19.3,23).lineTo(19.3,10.6).lineTo(20.8,10.6).lineTo(20.8,23).closePath().moveTo(9,23).lineTo(7.5,17.3).lineTo(6.7,17.4).lineTo(6,17.4).lineTo(6,23).lineTo(4.6,23).lineTo(4.6,6.7).lineTo(6,6.7).lineTo(6,16.1).lineTo(6.7,16.1).curveTo(7.2,16.1,7.4,15.8).curveTo(7.7,15.5,7.9,14.7).lineTo(8.7,10.6).lineTo(10.2,10.6).lineTo(9.3,14.8).curveTo(9.1,15.8,8.7,16.4).lineTo(10.5,23).closePath().moveTo(-20.7,23).lineTo(-20.7,10.6).lineTo(-19.6,10.6).lineTo(-19.4,12.3).curveTo(-19.3,11.6,-18.8,11.1).curveTo(-18.2,10.5,-17.2,10.4).lineTo(-17.1,12).curveTo(-18.1,12,-18.7,12.8).curveTo(-19.2,13.4,-19.2,14.7).lineTo(-19.2,23).closePath().moveTo(-30.4,23).lineTo(-30.4,7.1).lineTo(-28,7.1).curveTo(-26.4,7.1,-25.5,8).curveTo(-24.4,9,-24.4,10.9).lineTo(-24.4,11.9).curveTo(-24.4,14.1,-26.6,14.9).curveTo(-24.4,15.7,-24.4,18.1).lineTo(-24.4,19.3).curveTo(-24.4,21.2,-25.4,22.1).curveTo(-26.3,23,-27.9,23).closePath().moveTo(-28.9,21.8).lineTo(-28.1,21.8).curveTo(-25.8,21.8,-25.8,19.2).lineTo(-25.8,18.2).curveTo(-25.8,16.9,-26.4,16.2).curveTo(-27,15.5,-28.1,15.6).lineTo(-28.9,15.6).closePath().moveTo(-28.9,14.3).lineTo(-28.2,14.3).curveTo(-25.9,14.3,-25.9,11.7).lineTo(-25.9,11).curveTo(-25.9,8.4,-28.2,8.4).lineTo(-28.9,8.4).closePath().moveTo(19.1,7.9).curveTo(19.1,6.9,20.1,6.9).curveTo(21,6.9,21,7.9).curveTo(21,8.8,20.1,8.8).curveTo(19.1,8.8,19.1,7.9).closePath().moveTo(-31.2,-6.6).lineTo(-31.2,-22.2).curveTo(-31.2,-22.4,-31,-22.7).curveTo(-30.7,-22.9,-30.5,-22.9).lineTo(-28.9,-22.9).curveTo(-28.8,-22.9,-28.8,-22.9).curveTo(-28.7,-22.9,-28.7,-22.9).curveTo(-28.6,-22.8,-28.6,-22.8).curveTo(-28.5,-22.7,-28.5,-22.7).curveTo(-28.2,-22.4,-28.2,-22.2).lineTo(-28.2,-5.8).curveTo(-28.2,-3,-26.5,-3).curveTo(-24.8,-3,-24.8,-5.8).lineTo(-24.8,-22.2).curveTo(-24.8,-22.4,-24.5,-22.7).curveTo(-24.3,-22.9,-24,-22.9).lineTo(-22.5,-22.9).curveTo(-22.2,-22.9,-22,-22.7).curveTo(-21.8,-22.4,-21.8,-22.2).lineTo(-21.8,-6.6).curveTo(-21.8,-0.5,-26.5,-0.5).curveTo(-31.2,-0.5,-31.2,-6.6).closePath().moveTo(-45.9,-6.6).lineTo(-45.9,-17.2).curveTo(-45.9,-23.3,-41.1,-23.2).curveTo(-36.5,-23.3,-36.5,-17.2).lineTo(-36.5,-6.6).curveTo(-36.5,-0.5,-41.1,-0.5).curveTo(-45.9,-0.5,-45.9,-6.6).closePath().moveTo(-42.9,-18).lineTo(-42.9,-5.8).curveTo(-42.9,-3,-41.1,-3).curveTo(-39.4,-3,-39.4,-5.8).lineTo(-39.4,-18).curveTo(-39.4,-20.8,-41.1,-20.8).curveTo(-42.9,-20.8,-42.9,-18).closePath().moveTo(29.5,-0.7).curveTo(28.8,-0.8,28.8,-1.4).lineTo(28.4,-6.1).curveTo(28.3,-6.7,27.7,-6.7).lineTo(25.6,-6.7).curveTo(25,-6.7,24.9,-6.1).lineTo(24.5,-1.4).curveTo(24.4,-0.8,23.8,-0.7).lineTo(22.3,-0.7).curveTo(22,-0.7,21.8,-1).curveTo(21.6,-1.2,21.6,-1.5).curveTo(22.7,-14.1,24.1,-22.2).curveTo(24.2,-22.9,24.9,-22.9).lineTo(28.4,-22.9).curveTo(29,-22.9,29.1,-22.2).curveTo(30.5,-14.8,31.7,-1.5).curveTo(31.7,-1.2,31.5,-1).curveTo(31.3,-0.7,31,-0.7).closePath().moveTo(25.3,-10).curveTo(25.2,-9.7,25.5,-9.4).curveTo(25.7,-9.1,26,-9.2).lineTo(27.3,-9.2).curveTo(27.6,-9.1,27.8,-9.4).curveTo(28.1,-9.7,28,-10).curveTo(27.4,-16.3,26.9,-20.4).lineTo(26.4,-20.4).curveTo(25.9,-16.3,25.3,-10).closePath().moveTo(51.7,-0.9).curveTo(51.4,-0.9,51.2,-1.1).curveTo(50.9,-1.3,50.9,-1.5).lineTo(50.9,-22.2).curveTo(50.9,-22.5,51.2,-22.7).curveTo(51.4,-22.9,51.7,-22.9).lineTo(54.2,-22.9).curveTo(60.1,-22.9,60.1,-15.9).lineTo(60.1,-7.8).curveTo(60.1,-0.9,54.2,-0.9).closePath().moveTo(53.9,-3.3).lineTo(54.5,-3.3).curveTo(57.2,-3.3,57.2,-6.6).lineTo(57.2,-17.2).curveTo(57.2,-20.5,54.5,-20.5).lineTo(53.9,-20.5).closePath().moveTo(44.2,-0.9).curveTo(43.6,-0.8,43.5,-1.4).lineTo(41,-10.8).lineTo(40.1,-10.8).curveTo(39.8,-10.7,39.6,-10.5).curveTo(39.3,-10.3,39.3,-10.1).lineTo(39.3,-1.5).curveTo(39.3,-0.9,38.6,-0.9).lineTo(37.1,-0.9).curveTo(36.8,-0.9,36.6,-1.1).curveTo(36.4,-1.3,36.4,-1.5).lineTo(36.4,-22.2).curveTo(36.4,-22.5,36.6,-22.7).curveTo(36.8,-22.9,37.1,-22.9).lineTo(40.6,-22.9).curveTo(42.9,-22.9,44.3,-21.7).curveTo(45.8,-20.3,45.8,-17.6).lineTo(45.8,-16.1).curveTo(45.8,-13.3,44,-11.9).curveTo(43.6,-11.6,43.7,-11.1).lineTo(46.3,-1.8).curveTo(46.4,-1.4,46.2,-1.1).curveTo(46,-0.9,45.6,-0.9).closePath().moveTo(39.6,-20.2).curveTo(39.3,-20.1,39.3,-19.8).lineTo(39.3,-13.9).curveTo(39.3,-13.6,39.6,-13.4).curveTo(39.8,-13.2,40.1,-13.2).lineTo(40.2,-13.2).curveTo(42.8,-13.2,42.8,-16.4).lineTo(42.8,-17.4).curveTo(42.8,-20.5,40.2,-20.5).lineTo(40.1,-20.5).curveTo(39.8,-20.5,39.6,-20.2).closePath().moveTo(11.1,-0.9).curveTo(10.5,-0.9,10.3,-1.4).curveTo(9,-9.4,7.8,-22.1).curveTo(7.8,-22.4,8,-22.7).curveTo(8.2,-22.9,8.6,-22.9).lineTo(10,-22.9).curveTo(10.7,-22.9,10.8,-22.2).curveTo(11.6,-11.4,12.6,-3.3).lineTo(13.1,-3.3).curveTo(14,-10.1,15,-22.2).curveTo(15,-22.5,15.2,-22.8).curveTo(15.4,-22.9,15.7,-22.9).lineTo(17.2,-22.9).curveTo(17.5,-22.9,17.8,-22.7).curveTo(18,-22.4,17.9,-22.1).curveTo(16.8,-9.3,15.4,-1.4).curveTo(15.3,-0.9,14.6,-0.9).closePath().moveTo(-3.1,-0.9).curveTo(-3.4,-0.9,-3.6,-1.1).curveTo(-3.9,-1.3,-3.9,-1.5).lineTo(-3.9,-22.2).curveTo(-3.9,-22.5,-3.6,-22.7).curveTo(-3.4,-22.9,-3.1,-22.9).lineTo(3,-22.9).curveTo(3.4,-22.9,3.5,-22.7).curveTo(3.8,-22.4,3.8,-22.2).lineTo(3.8,-21.2).curveTo(3.8,-20.9,3.5,-20.7).curveTo(3.4,-20.5,3,-20.5).lineTo(-0.1,-20.5).curveTo(-0.4,-20.5,-0.7,-20.2).curveTo(-0.9,-20.1,-0.9,-19.8).lineTo(-0.9,-13.9).curveTo(-0.9,-13.6,-0.7,-13.4).curveTo(-0.4,-13.2,-0.1,-13.2).lineTo(2.3,-13.2).curveTo(2.6,-13.2,2.9,-13).curveTo(3.1,-12.8,3.1,-12.4).lineTo(3.1,-11.5).curveTo(3.1,-11.2,2.9,-11).curveTo(2.6,-10.8,2.3,-10.8).lineTo(-0.1,-10.8).curveTo(-0.4,-10.7,-0.7,-10.5).curveTo(-0.9,-10.3,-0.9,-10.1).lineTo(-0.9,-4).curveTo(-0.9,-3.7,-0.7,-3.5).curveTo(-0.4,-3.3,-0.1,-3.3).lineTo(3,-3.3).curveTo(3.4,-3.3,3.5,-3.1).curveTo(3.8,-2.8,3.8,-2.5).lineTo(3.8,-1.5).curveTo(3.8,-1.3,3.5,-1.1).curveTo(3.4,-0.9,3,-0.9).closePath().moveTo(-15.6,-0.9).curveTo(-16.3,-0.9,-16.3,-1.5).lineTo(-16.3,-22.2).curveTo(-16.3,-22.5,-16.1,-22.7).curveTo(-15.9,-22.9,-15.6,-22.9).lineTo(-14.1,-22.9).curveTo(-13.8,-22.9,-13.6,-22.7).curveTo(-13.4,-22.5,-13.4,-22.2).lineTo(-13.4,-4).curveTo(-13.4,-3.7,-13.2,-3.5).curveTo(-13,-3.3,-12.6,-3.3).lineTo(-9,-3.3).curveTo(-8.7,-3.3,-8.4,-3.1).curveTo(-8.2,-2.8,-8.2,-2.5).lineTo(-8.2,-1.5).curveTo(-8.2,-1.3,-8.4,-1.1).curveTo(-8.7,-0.9,-9,-0.9).closePath().moveTo(-59.4,-0.9).curveTo(-59.7,-0.9,-59.9,-1.1).curveTo(-60.1,-1.3,-60.1,-1.5).lineTo(-60.1,-22.2).curveTo(-60.1,-22.4,-59.9,-22.7).curveTo(-59.7,-22.9,-59.4,-22.9).lineTo(-56.1,-22.9).curveTo(-53.7,-22.9,-52.3,-21.7).curveTo(-50.8,-20.3,-50.8,-17.6).lineTo(-50.8,-16.1).curveTo(-50.8,-13.9,-52.5,-12.7).curveTo(-52.8,-12.5,-52.8,-12).curveTo(-52.8,-11.6,-52.5,-11.4).curveTo(-50.7,-10.2,-50.7,-7.9).lineTo(-50.7,-6.1).curveTo(-50.7,-3.5,-52.2,-2.2).curveTo(-53.6,-0.9,-55.9,-0.9).closePath().moveTo(-56.9,-10.5).curveTo(-57.1,-10.3,-57.1,-10.1).lineTo(-57.1,-4).curveTo(-57.1,-3.7,-56.9,-3.5).curveTo(-56.7,-3.3,-56.4,-3.3).lineTo(-56.2,-3.3).curveTo(-53.6,-3.3,-53.6,-6.4).lineTo(-53.6,-7.7).curveTo(-53.6,-10.8,-56.2,-10.8).lineTo(-56.4,-10.8).curveTo(-56.7,-10.7,-56.9,-10.5).closePath().moveTo(-57.1,-13.2).lineTo(-56.3,-13.2).curveTo(-53.8,-13.2,-53.8,-16.3).lineTo(-53.8,-17.4).curveTo(-53.8,-20.5,-56.3,-20.5).lineTo(-57.1,-20.5).closePath();
	this.shape_2.setTransform(51.225,42.65);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},2).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-66.3,0,258.4,65.9);


(lib.logo_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// logo
	this.text = new cjs.Text("Before", "200px 'Montserrat Medium'", "#FFFFFF");
	this.text.textAlign = "center";
	this.text.lineHeight = 314;
	this.text.lineWidth = 676;
	this.text.parent = this;
	this.text.setTransform(233.35,2);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.logo_1, new cjs.Rectangle(-106.5,0,679.7,557.6), null);


(lib.ClipGroup_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-525.6,694.5).lineTo(-525.6,-694.5).lineTo(525.6,-694.5).lineTo(525.6,694.5).closePath();
	mask.setTransform(525.575,694.55);

	// Camada_3
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2).moveTo(-346.4,-141.8).lineTo(-346.4,141.9).curveTo(-346.4,168.9,-332.9,192.2).curveTo(-319.4,215.6,-296,229.1).lineTo(-50.3,370.9).curveTo(-27,384.3,0,384.3).curveTo(27,384.3,50.4,370.9).lineTo(296.1,229.1).curveTo(319.5,215.6,333,192.2).curveTo(346.4,168.9,346.4,141.9).lineTo(346.4,-141.8).curveTo(346.4,-168.8,333,-192.1).curveTo(319.5,-215.5,296.1,-229).lineTo(50.4,-370.8).curveTo(27,-384.3,0,-384.3).curveTo(-27,-384.3,-50.3,-370.8).lineTo(-296,-229).curveTo(-319.4,-215.5,-332.9,-192.1).curveTo(-346.4,-168.8,-346.4,-141.8).closePath();
	this.shape.setTransform(348.4,1002.725);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill().beginStroke("#FFFFFF").setStrokeStyle(2).moveTo(-346.4,-141.9).lineTo(-346.4,141.8).curveTo(-346.4,168.8,-332.9,192.2).curveTo(-319.4,215.5,-296.1,229).lineTo(-50.3,370.9).curveTo(-27,384.4,0,384.4).curveTo(27,384.4,50.3,370.9).lineTo(296.1,229).curveTo(319.4,215.5,332.9,192.2).curveTo(346.4,168.8,346.4,141.8).lineTo(346.4,-141.9).curveTo(346.4,-168.8,332.9,-192.2).curveTo(319.4,-215.6,296.1,-229).lineTo(50.3,-370.9).curveTo(27,-384.4,0,-384.4).curveTo(-27,-384.4,-50.3,-370.9).lineTo(-296.1,-229).curveTo(-319.4,-215.6,-332.9,-192.2).curveTo(-346.4,-168.8,-346.4,-141.9).closePath();
	this.shape_1.setTransform(702.725,386.375);

	var maskedShapeInstanceList = [this.shape,this.shape_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_5, new cjs.Rectangle(1,1,1049.2,1387.1), null);


(lib.ClipGroup_4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-534.4,1099.2).lineTo(-534.4,-1099.2).lineTo(534.4,-1099.2).lineTo(534.4,1099.2).closePath();
	mask.setTransform(534.4,1099.225);

	// Camada_3
	this.instance = new lib.CachedBmp_2();
	this.instance.setTransform(0.95,1,0.31,0.31);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_4, new cjs.Rectangle(1,1,1066.8,2196.4), null);


(lib.ClipGroup_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-596.3,420.9).lineTo(-596.3,-420.9).lineTo(596.3,-420.9).lineTo(596.3,420.9).closePath();
	mask.setTransform(596.325,420.925);

	// Camada_3
	this.instance = new lib.Image();
	this.instance.setTransform(0,0,0.7795,0.7795);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_2, new cjs.Rectangle(0,0,1192.7,841.9), null);


(lib.cloud1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Nuvem1();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.cloud1, new cjs.Rectangle(0,0,793,500), null);


(lib.button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// pseudo
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(3).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-64,-64,128,128);


(lib.bg2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Bitmap1();
	this.instance.setTransform(-960,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bg2, new cjs.Rectangle(-960,-540,1920,1080), null);


(lib.nuvem1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_3
	this.instance = new lib.cloud1();
	this.instance.setTransform(-96.5,413.7,0.5442,0.7796,-27.4733,0,0,396.2,250);
	this.instance.alpha = 0.1992;
	var instanceFilter_1 = new cjs.ColorFilter(1,1,1,1,45,10,35,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-2,-2,797,504);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:396.4,scaleX:0.2784,scaleY:0.3988,rotation:-27.471,x:1123.3,y:879.35,alpha:0.1484},1679).to({_off:true},1).wait(199));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(1878));

	// Camada_2
	this.instance_1 = new lib.cloud1();
	this.instance_1.setTransform(2815.45,-23.45,1.3866,2.3632,0,36.5905,-163.2715,396.2,249.7);
	this.instance_1.alpha = 0.1406;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(263).to({_off:false},0).to({regX:396.4,regY:250.1,scaleX:0.5754,scaleY:0.7582,skewX:17.434,skewY:-162.5673,x:1199.15,y:615.2},1615).wait(1));

	// Camada_1
	this.instance_2 = new lib.cloud1();
	this.instance_2.setTransform(-409.2,-157.05,1.8494,2.6494,-19.1686,0,0,396.4,249.9);
	this.instance_2.alpha = 0.1797;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:396.6,regY:250.2,scaleX:0.6326,scaleY:0.6262,rotation:-27.9495,x:1190.7,y:725.05,alpha:0.1484},1599).to({_off:true},1).wait(279));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1319,-1023.2,5012.3,2041.9);


(lib.go_back = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button
	this.instance = new lib.button();
	this.instance.setTransform(20.25,40.25,0.3126,0.6252,0,0,0,0.8,0.4);
	new cjs.ButtonHelper(this.instance, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// text
	this.instance_1 = new lib.CachedBmp_15();
	this.instance_1.setTransform(8.5,21.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#990000").beginStroke().moveTo(-20,40).lineTo(-20,-40).lineTo(20,-40).lineTo(20,40).closePath();
	this.shape.setTransform(20,40);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.go_back, new cjs.Rectangle(0,0,40,80), null);


(lib.title = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vertical
	this.instance = new lib.vertical();
	this.instance.setTransform(1500.4,13.25);

	this.instance_1 = new lib.vertical();
	this.instance_1.setTransform(1252.3,13.25);

	this.instance_2 = new lib.vertical();
	this.instance_2.setTransform(1413.95,13.25);

	this.instance_3 = new lib.vertical();
	this.instance_3.setTransform(761.85,13.25);

	this.instance_4 = new lib.vertical();
	this.instance_4.setTransform(1138.2,13.25);

	this.instance_5 = new lib.vertical();
	this.instance_5.setTransform(932.75,13.25);

	this.instance_6 = new lib.vertical();
	this.instance_6.setTransform(570.1,13.25);

	this.instance_7 = new lib.vertical();
	this.instance_7.setTransform(405.1,13.25);

	this.instance_8 = new lib.vertical();
	this.instance_8.setTransform(244.45,13.25);

	this.instance_9 = new lib.vertical();
	this.instance_9.setTransform(74.45,13.25);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// square
	this.instance_10 = new lib.square();
	this.instance_10.setTransform(4,4);
	this.instance_10.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// ball
	this.instance_11 = new lib.ball();
	this.instance_11.setTransform(76.5,14);
	this.instance_11.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(1));

	// title
	this.instance_12 = new lib.CachedBmp_14();
	this.instance_12.setTransform(1516.25,1,0.5,0.5);

	this.instance_13 = new lib.CachedBmp_13();
	this.instance_13.setTransform(2.1,1,0.5,0.5);

	this.instance_14 = new lib.CachedBmp_12();
	this.instance_14.setTransform(98.75,1,0.5,0.5);

	this.instance_15 = new lib.CachedBmp_11();
	this.instance_15.setTransform(266.5,1,0.5,0.5);

	this.instance_16 = new lib.CachedBmp_10();
	this.instance_16.setTransform(424.3,1,0.5,0.5);

	this.instance_17 = new lib.CachedBmp_9();
	this.instance_17.setTransform(592.15,1,0.5,0.5);

	this.instance_18 = new lib.CachedBmp_8();
	this.instance_18.setTransform(779.05,1,0.5,0.5);

	this.instance_19 = new lib.CachedBmp_7();
	this.instance_19.setTransform(953.25,1,0.5,0.5);

	this.instance_20 = new lib.CachedBmp_6();
	this.instance_20.setTransform(1157.2,1,0.5,0.5);

	this.instance_21 = new lib.CachedBmp_5();
	this.instance_21.setTransform(1272.35,1,0.5,0.5);

	this.instance_22 = new lib.CachedBmp_4();
	this.instance_22.setTransform(1431.45,1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_22},{t:this.instance_21},{t:this.instance_20},{t:this.instance_19},{t:this.instance_18},{t:this.instance_17},{t:this.instance_16},{t:this.instance_15},{t:this.instance_14},{t:this.instance_13},{t:this.instance_12}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.title, new cjs.Rectangle(0,0,1574.3,26), null);


(lib.effect_up = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {start:1,complete:10,end:19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// effect
	this.instance = new lib.arrow_up();
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({y:-30},4).to({y:-22.65},2).to({y:-30},2).wait(2).to({y:0},8).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-22.6,11.3).lineTo(-0.1,-11.3).lineTo(22.6,11.3).closePath();
	this.shape.setTransform(0,11.325);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.6,-30,45.2,52.7);


(lib.background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line_solid
	this.instance = new lib.solid();
	this.instance.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// line_gradient
	this.instance_1 = new lib.gradient();
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// line_double
	this.instance_2 = new lib._double();
	this.instance_2.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// background
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#263B57").beginStroke().moveTo(-960,16).lineTo(-960,-16).lineTo(960,-16).lineTo(960,16).closePath();
	this.shape.setTransform(960,41.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.background, new cjs.Rectangle(-1,-2,1922,63), null);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"start":1,"complete":10,"end":19};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectStart(library_name, 'before');
	}
	this.frame_9 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectComplete(library_name, 'before');
	}
	this.frame_19 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.effectEnd(library_name, 'before');
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(9).call(this.frame_9).wait(10).call(this.frame_19).wait(1));

	// logo
	this.instance = new lib.logo_1();
	this.instance.setTransform(726.65,360.1);
	this.instance.alpha = 0;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({alpha:1},8).wait(2).to({alpha:0},8).wait(1));

	// button
	this.btn_start = new lib.button();
	this.btn_start.name = "btn_start";
	this.btn_start.setTransform(952.25,795.4);
	this.btn_start._off = true;
	new cjs.ButtonHelper(this.btn_start, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_start).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// menu
	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#00FF00").beginStroke().moveTo(-64,64).lineTo(-64,-64).lineTo(64,-64).lineTo(64,64).closePath();
	this.shape.setTransform(952.25,795.4);
	this.shape._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(9).to({_off:false},0).to({_off:true},2).wait(9));

	// size
	this.instance_1 = new lib.size_1920x1080();
	this.instance_1.setTransform(960,540,1,1,0,0,0,960,540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(20));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.Group_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.ClipGroup_4();
	this.instance.setTransform(534.4,1099.2,1,1,0,0,0,534.4,1099.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Group_1, new cjs.Rectangle(0,0,1068.8,2198.5), null);


(lib.Group = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.ClipGroup_5();
	this.instance.setTransform(525.5,694.6,1,1,0,0,0,525.5,694.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Group, new cjs.Rectangle(0,0,1051.2,1389.1), null);


(lib.ClipGroup_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-595.3,420.9).lineTo(-595.3,-420.9).lineTo(595.3,-420.9).lineTo(595.3,420.9).closePath();
	mask.setTransform(596.325,420.925);

	// Camada_3
	this.instance = new lib.ClipGroup_2();
	this.instance.setTransform(596.3,420.9,1,1,0,0,0,596.3,420.9);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_1, new cjs.Rectangle(1.1,0,1190.5,841.9), null);


(lib.animaNuvem = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Fachada_recorte();
	this.instance.setTransform(-193,-509);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Camada_2
	this.instance_1 = new lib.nuvem1();
	this.instance_1.setTransform(-695,-298.45,0.8793,0.7279,0,0,0,396.4,250);
	this.instance_1.alpha = 0.8594;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));
	this.instance_1.addEventListener("tick", AdobeAn.handleFilterCache);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.animaNuvem, new cjs.Rectangle(-2203.3,-1225.1,2396.3,1734.1), null);


(lib.ClipGroup_0 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-596.3,421.9).lineTo(-596.3,-421.9).lineTo(596.3,-421.9).lineTo(596.3,421.9).closePath();
	mask.setTransform(596.325,421.9);

	// Camada_3
	this.instance = new lib.ClipGroup_1();
	this.instance.setTransform(596.3,421.9,1,1,0,0,0,596.3,420.9);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_0, new cjs.Rectangle(0.1,1,1192.5,841.9), null);


(lib.marker = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1,frame02:2,frame03:3,frame04:4,frame05:5,frame06:6,frame07:7,frame08:8,frame09:9,frame10:10,frame11:11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// arrow_up
	this.occ_animate = new lib.effect_up();
	this.occ_animate.name = "occ_animate";
	this.occ_animate.setTransform(38.45,0);
	this.occ_animate._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_animate).wait(2).to({_off:false},0).wait(1).to({x:147.65},0).wait(1).to({x:290.2},0).wait(1).to({x:468.05},0).wait(1).to({x:644.85},0).wait(1).to({x:812.8},0).wait(1).to({x:988.35},0).wait(1).to({x:1158.1},0).wait(1).to({x:1299.9},0).wait(1).to({x:1454.6},0).wait(1));

	// size
	this.instance = new lib.size_90x90();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1477.2,90);


(lib.Group_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.ClipGroup_0();
	this.instance.setTransform(596.3,421.9,1,1,0,0,0,596.3,421.9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Group_2, new cjs.Rectangle(0,0,1192.7,843.8), null);


(lib.ClipGroup_3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.moveTo(-595.3,420.9).lineTo(-595.3,-420.9).lineTo(595.3,-420.9).lineTo(595.3,420.9).closePath();
	mask.setTransform(723.075,1097.275);

	// Camada_3
	this.instance = new lib.Group();
	this.instance.setTransform(1258.9,889.75,1,1,0,0,0,525.5,694.6);
	this.instance.alpha = 0.5;

	this.instance_1 = new lib.Group_1();
	this.instance_1.setTransform(534.4,1099.2,1,1,0,0,0,534.4,1099.2);
	this.instance_1.alpha = 0.3008;

	this.instance_2 = new lib.Group_2();
	this.instance_2.setTransform(723.05,1097.25,1,1,0,0,0,596.3,421.9);
	this.instance_2.alpha = 0.5508;

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ClipGroup_3, new cjs.Rectangle(127.8,676.4,1190.6000000000001,841.8000000000001), null);


(lib.capaAnima = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.instance = new lib.animaNuvem();
	this.instance.setTransform(-231.35,-19.75);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Camada_1
	this.instance_1 = new lib.fachada();
	this.instance_1.setTransform(-1195.95,-540);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.capaAnima, new cjs.Rectangle(-2434.6,-1244.9,3158.7,1784.9), null);


(lib.background_dynamic = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2,"frame03":3,"frame04":4,"frame05":5,"frame06":6,"frame07":7,"frame08":8,"frame09":9,"frame10":10,"frame11":11};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(12));

	// background
	this.instance = new lib.capaAnima();
	this.instance.setTransform(1196.15,540.4,1,1,0,0,0,0.2,0.4);

	this.shape = new cjs.Shape();
	this.shape.graphics.beginFill("#1A2940").beginStroke().moveTo(-959.4,540).lineTo(-959.4,-540).lineTo(959.4,-540).lineTo(959.4,540).closePath();
	this.shape.setTransform(959.9463,540,1.0006,1);

	this.instance_1 = new lib.bg2();
	this.instance_1.setTransform(961.25,540.15);

	this.instance_2 = new lib.CachedBmp_3();
	this.instance_2.setTransform(0,0,0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-917.8,466).lineTo(-917.8,-466).lineTo(917.8,-466).lineTo(917.8,466).closePath();
	this.shape_1.setTransform(960,512.0541,1,1.0258);

	this.instance_3 = new lib.ClipGroup_3();
	this.instance_3.setTransform(1232.7,681.9,1.6127,1.6127,0,0,0,892.2,1099.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.beginFill("#FFFFFF").beginStroke().moveTo(-960,540).lineTo(-960,-540).lineTo(960,-540).lineTo(960,540).closePath();
	this.shape_2.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.shape}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_1},{t:this.shape_1}]},2).to({state:[{t:this.shape_2},{t:this.instance_3}]},2).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(12));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1238.6,-1090.7,3910.4,3545.3999999999996);


(lib.content_frame_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		// const gotoPage = (event, {url}) => {
		//     /**
		//      * Go back page for portal.
		//      */
		//     window.open(url, '_self');
		// }
		//
		// this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		// this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage, false, false, {url: 'http://portal-terra-web.local'});
		    
		const gotoPage = () => {
		    /**
		     * Close page with extension plugin chrome.
		     */
			//chrome.runtime.sendMessage('maglcmgfenlbeehaeohfbkncflcafmko', {action: 'closeBrowser'});
		    /**
		     * Close page with window browser.
		     */
			window.close();
		}
		
		this._handleGoBack && this.btn_go_back.off('mousedown', this._handleGoBack);
		this._handleGoBack = this.btn_go_back.on('mousedown', gotoPage);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// go_back
	this.btn_go_back = new lib.go_back();
	this.btn_go_back.name = "btn_go_back";
	this.btn_go_back.setTransform(1879.95,1000);
	this.btn_go_back.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.btn_go_back).wait(1));

	// button
	this.btn_page13 = new lib.button();
	this.btn_page13.name = "btn_page13";
	this.btn_page13.setTransform(1845.7,1039.05,0.4515,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page13, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page09 = new lib.button();
	this.btn_page09.name = "btn_page09";
	this.btn_page09.setTransform(1335.45,1039.05,1.32,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page09, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page08 = new lib.button();
	this.btn_page08.name = "btn_page08";
	this.btn_page08.setTransform(1142.65,1039.05,1.0238,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page08, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page07 = new lib.button();
	this.btn_page07.name = "btn_page07";
	this.btn_page07.setTransform(1078.9,1117.8,0.8908,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page07, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page12 = new lib.button();
	this.btn_page12.name = "btn_page12";
	this.btn_page12.setTransform(1759.9,1039.05,0.4515,0.4688,0,0,0,0.6,0.1);
	new cjs.ButtonHelper(this.btn_page12, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page11 = new lib.button();
	this.btn_page11.name = "btn_page11";
	this.btn_page11.setTransform(1633.45,1039.05,0.9651,0.4688,0,0,0,0.5,0.1);
	new cjs.ButtonHelper(this.btn_page11, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page10 = new lib.button();
	this.btn_page10.name = "btn_page10";
	this.btn_page10.setTransform(1494.85,1039.05,0.6039,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page10, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page06 = new lib.button();
	this.btn_page06.name = "btn_page06";
	this.btn_page06.setTransform(969,1039.05,1.166,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page06, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page05 = new lib.button();
	this.btn_page05.name = "btn_page05";
	this.btn_page05.setTransform(787.2,1039.05,1.0158,0.4688,0,0,0,0.4,0.1);
	new cjs.ButtonHelper(this.btn_page05, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page04 = new lib.button();
	this.btn_page04.name = "btn_page04";
	this.btn_page04.setTransform(626.8,1039.05,1.0192,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page04, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page03 = new lib.button();
	this.btn_page03.name = "btn_page03";
	this.btn_page03.setTransform(460.05,1039.05,1.069,0.4688,0,0,0,0.3,0.1);
	new cjs.ButtonHelper(this.btn_page03, 0, 1, 2, false, new lib.button(), 3);

	this.btn_page02 = new lib.button();
	this.btn_page02.name = "btn_page02";
	this.btn_page02.setTransform(329.55,1039.05,0.4445,0.4688,0,0,0,0.2,0.1);
	new cjs.ButtonHelper(this.btn_page02, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_page02},{t:this.btn_page03},{t:this.btn_page04},{t:this.btn_page05},{t:this.btn_page06},{t:this.btn_page10},{t:this.btn_page11},{t:this.btn_page12},{t:this.btn_page07},{t:this.btn_page08},{t:this.btn_page09},{t:this.btn_page13}]}).wait(1));

	// button_logo
	this.btn_back = new lib.button();
	this.btn_back.name = "btn_back";
	this.btn_back.setTransform(145.4,1040.05,1.9531,0.625,0,0,0,0.2,0.1);
	this.btn_back.visible = false;
	new cjs.ButtonHelper(this.btn_back, 0, 1, 2, false, new lib.button(), 3);

	this.timeline.addTween(cjs.Tween.get(this.btn_back).wait(1));

	// marker
	this.occ_marker = new lib.marker();
	this.occ_marker.name = "occ_marker";
	this.occ_marker.setTransform(283.45,1080);

	this.timeline.addTween(cjs.Tween.get(this.occ_marker).wait(1));

	// marker_slider
	this.occ_marker_slider = new lib.arrow_up();
	this.occ_marker_slider.name = "occ_marker_slider";
	this.occ_marker_slider.setTransform(328.8,1057.35);
	this.occ_marker_slider.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_marker_slider).wait(1));

	// pseudo
	this.instance = new lib.pseudo();
	this.instance.setTransform(1074.15,1087.75);
	this.instance.visible = false;

	this.instance_1 = new lib.pseudo();
	this.instance_1.setTransform(1730.1,1087,1.1053,1);
	this.instance_1.visible = false;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// title
	this.instance_2 = new lib.title();
	this.instance_2.setTransform(301,1027);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// logo
	this.occ_logo = new lib.logo();
	this.occ_logo.name = "occ_logo";
	this.occ_logo.setTransform(141.65,1010);
	this.occ_logo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_logo).wait(1));

	// background
	this.instance_3 = new lib.background();
	this.instance_3.setTransform(0,1000);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// background_dynamic
	this.occ_dynamic = new lib.background_dynamic();
	this.occ_dynamic.name = "occ_dynamic";
	this.occ_dynamic.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_dynamic).wait(1));

	// size
	this.instance_4 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_02, new cjs.Rectangle(-1,0,1922,1170), null);


// stage content:
(lib.index = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"frame01":1,"frame02":2};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.main.scene.layerActions.frame01Index(this, library_name);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(2));

	// Model
	this.instance = new lib.zoom_brack();
	this.instance.setTransform(16.8,-40.9,1,1,0,0,0,0.3,0.3);

	this.instance_1 = new lib.zoom_white();
	this.instance_1.setTransform(102.35,-40.9,1,1,0,0,0,0.3,0.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[]},1).wait(2));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";

	this.instance_2 = new lib.CachedBmp_16();
	this.instance_2.setTransform(-287.7,1095.95,0.5,0.5);

	this.occ_frame_02 = new lib.content_frame_02();
	this.occ_frame_02.name = "occ_frame_02";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.occ_frame_01}]},1).to({state:[{t:this.occ_frame_02},{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(672.3,480.6,1248.7,901.9);
// library properties:
lib.properties = {
	id: '8D6FF2B23DC06844BB2994587C24925D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"./images/CachedBmp_3.png?1783435189852", id:"CachedBmp_3"},
		{src:"./images/CachedBmp_2.png?1783435189852", id:"CachedBmp_2"},
		{src:"./images/index_atlas_1.png?1783435189812", id:"index_atlas_1"},
		{src:"./images/index_atlas_2.png?1783435189812", id:"index_atlas_2"},
		{src:"./images/index_atlas_3.png?1783435189812", id:"index_atlas_3"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['8D6FF2B23DC06844BB2994587C24925D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
 